module.exports = __webpack_public_path__ + "static/4x_hr_onboarding_4-8139d741168eef406ad112e8471a2050.png";